import {useMemo} from 'react';
import {useQuery} from 'react-query';
import {fetchLookupHistory} from '../requests/queries/lookup';
import {useAllApps} from './useApps';
import {useSelector} from 'react-redux';

export const useLookupHistory = ({IDENTITY_TYPES = [], otherParams}) => {
  const {userApps, isLoading: appsLoading} = useAllApps();
  const {userDetails} = useSelector(state => state?.auth);

  const params = useMemo(
    () =>
      !appsLoading &&
      userApps && {
        company_id: userDetails?.company?.id,
        entity_types: IDENTITY_TYPES?.join(','),
        ...otherParams,
        app_ids: otherParams?.app_ids
          ? otherParams?.app_ids
          : userApps.map(app => app?.value)?.join(','),
      },
    [
      appsLoading,
      userApps,
      userDetails?.company?.id,
      IDENTITY_TYPES,
      otherParams,
    ],
  );

  const {
    data: history_data,
    isLoading: historyLoading,
    refetch,
  } = useQuery(
    ['lookup-histories', {params}],
    () => fetchLookupHistory({params}),
    {
      enabled: userApps?.length > 0,
    },
  );

  const historyData = useMemo(
    () => !historyLoading && history_data && history_data,
    [historyLoading, history_data],
  );
  return {historyData, historyLoading, refetch};
};
